// extracted by mini-css-extract-plugin
export default {"chips":"Chips_chips__aMtpJ","chips__count":"Chips_chips__count__YaehU","chips__leading":"Chips_chips__leading__mYLvM"};